import React from 'react'
import ModalComponent from '..'
import { Button } from '../../button'

export const ConfirmationModal = ({
  open,
  setOpen,
  message,
  title = 'Confirm Deletion',
  onCloseCallback,
  onConfirm,
  loading,
  confirmText = 'Delete',
}: {
  open: boolean
  setOpen: (val: boolean) => void
  message: React.ReactNode
  title?: string
  onCloseCallback?: () => void
  onConfirm: () => void
  loading?: boolean
  confirmText?: string
}) => {
  return (
    <ModalComponent
      open={open}
      setOpen={setOpen}
      onCloseCallback={onCloseCallback}
      title={''}
      childrenClassName="md:!max-w-[420px]"
      showHeader={false}
    >
      <div className="flex flex-col text-center justify-center items-center gap-2">
        <p className="text-xl font-semibold">{title}</p>

        <div className="text-base text-sec-black">{message}</div>

        <div className="grid grid-cols-1 w-full mt-4">
          <Button
            label={confirmText}
            loading={loading}
            disabled={loading}
            onClick={() => {
              onConfirm()
            }}
            primary
          />

          <Button
            label="Cancel"
            onClick={() => {
              onCloseCallback?.()
              setOpen(false)
            }}
            primary={false}
            className="!bg-transparent !text-black !border-none"
          />
        </div>
      </div>
    </ModalComponent>
  )
}
